var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"absolute":""}},[_c('v-spacer'),_c('span',{staticClass:"font-weight-light"},[_vm._v("v "+_vm._s(_vm.env.VUE_APP_VERSION))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }